import React from 'react';

import IconButton from '@atlaskit/button/icon/button';
import LinkIconButton from '@atlaskit/button/icon/link';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { PanelAction } from '@atlassian/panel-system';

import type { PreviewPanelActionProps } from './types';

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanelAction: React.ForwardRefExoticComponent<
	Omit<PreviewPanelActionProps, 'ref'> & React.RefAttributes<any>
> = React.forwardRef(function PreviewPanelAction(
	{ icon, label, onClick, href, testId, analyticsContext }: PreviewPanelActionProps,
	ref: React.Ref<any>,
) {
	if (fg('ads-panel-system-gpp')) {
		if (analyticsContext || href) {
			return href ? (
				<LinkIconButton
					icon={icon}
					label={label}
					onClick={onClick}
					href={href}
					testId={testId}
					analyticsContext={analyticsContext}
					appearance="subtle"
					target="_blank"
					ref={ref}
					role="button"
				/>
			) : (
				<IconButton
					icon={icon}
					label={label}
					onClick={onClick}
					testId={testId}
					analyticsContext={analyticsContext}
					appearance="subtle"
					ref={ref}
					role="button"
				/>
			);
		}

		return (
			<PanelAction
				ref={ref}
				icon={icon}
				label={label}
				onClick={onClick}
				testId={testId}
				appearance="subtle"
			/>
		);
	}

	return href ? (
		<LinkIconButton
			icon={icon}
			label={label}
			onClick={onClick}
			href={href}
			testId={testId}
			analyticsContext={analyticsContext}
			appearance="subtle"
			target="_blank"
			ref={ref}
			role="button"
		/>
	) : (
		<IconButton
			icon={icon}
			label={label}
			onClick={onClick}
			testId={testId}
			analyticsContext={analyticsContext}
			appearance="subtle"
			ref={ref}
			role="button"
		/>
	);
});
